import React from 'react';
import './Page.css';

const pdfIcon = (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#5a5a5a"/>
    <path d="M14 2V8H20" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 13H8M16 17H8M10 9H8" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

function RegulatoryDetails() {
  return (
    <div className="page regulatory-details-page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Regulatory Details</h1>
        </div>

        <div className="regulatory-card">
          <div className="regulatory-card-text">
            <p className="regulatory-text">
              YK2 Partners LLP is Authorized and Regulated by the Financial Conduct Authority
            </p>
          </div>
          <ul className="regulatory-doc-links">
            <li>
              <a href="/Remediated-PDFs/Remuneration-Code-Disclosure.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download Remuneration Code Disclosure PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">Remuneration Code Disclosure</span>
              </a>
            </li>
            <li>
              <a href="/Remediated-PDFs/Stewardship-Code-Disclosure.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download UK Stewardship Code Disclosure PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">UK Stewardship Code Disclosure</span>
              </a>
            </li>
            <li>
              <a href="/Remediated-PDFs/Shareholders-Right-Directive-Disclosures.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download Shareholder Rights Directive Disclosures PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">Shareholder Rights Directive Disclosures</span>
              </a>
            </li>
          </ul>
        </div>

        <div className="regulatory-card">
          <div className="regulatory-card-text">
            <p className="regulatory-text">
              YK2 Partners Private Limited is the Investment Manager for YK2 Partners India Equity Fund (Category III Alternative Investment Fund with Registration Number: IN/AIF3/23-24/1386)
            </p>
            <p className="regulatory-text">
              Compliance officer: Hemant Balyan | Email: <a href="mailto:hemant@yk2partners.com" aria-label="Email compliance officer Hemant Balyan">hemant@yk2partners.com</a>
            </p>
          </div>
          <ul className="regulatory-doc-links">
            <li>
              <a href="/Remediated-PDFs/Investor-CharterSept2024.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download AIF Investor Charter Document PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">AIF Investor Charter Document</span>
              </a>
            </li>
            <li>
              <a href="/Remediated-PDFs/AIFComplaintsData.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download AIF Complaints Data PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">AIF Complaints Data</span>
              </a>
            </li>
            <li>
              <a href="/Remediated-PDFs/Investor grievance data - Mar-2026 - Remediated.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download Investor Grievance Data - March 2026 PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">Investor Grievance Data - March 2026</span>
              </a>
            </li>
            <li>
              <a href="/Remediated-PDFs/AIF-Stewardship-Policy-New.pdf" className="regulatory-doc-link" target="_blank" rel="noopener noreferrer" aria-label="Download AIF Stewardship Policy PDF (opens in new tab)">
                <span className="regulatory-doc-icon" aria-hidden="true">{pdfIcon}</span>
                <span className="regulatory-doc-name">AIF Stewardship Policy</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default RegulatoryDetails;
